export default __webpack_public_path__ + "static/media/favicon.8d2933b8.ico";